const setHeightForWidget = (event, document, isXs) => {
    if (document.getElementById('my-iframe') !== null && event.data?.type === 'onFdpqWidgetHeightChanged') {
        const initialHeight = isXs ? 380 : 287;
        document.getElementById('my-iframe').height = event.data?.height || initialHeight + 'px';
    }
};

export default setHeightForWidget;
